import { SlackNotificationEvent } from 'api/integrations/slack/slack.types';
import { EventType } from 'api/notifications/meta';

export type NotificationGroupTypes = {
  type: NotificationGroups;
  label: string;
  icon?: string | JSX.Element;
  collapse?: boolean;
  notifications?: SlackNotificationEvent[];
  timeConfigurable?: EventType[];
};

export type NotificationActionTypes = {
  onNotificationChange: (value: SlackNotificationEvent[]) => void;
};

export enum NotificationGroups {
  Task = 'Task',
  Message = 'Message',
  Project = 'Project',
  Phase = 'Phase',
  Space = 'Space',
  Remainders = 'Remainders',
  TasksDigest = 'Tasks Digest',
  Approvals = 'Approvals',
}
